// Agent edit form + promote-to-org flow incl. inline promotion progress
// (WEB-8003). AgentConfig feature styles. Composed by workspaceStyles.ts
// in place.
export const agentConfigEditFormAndPromotion = `
/* ===== Agent edit form ===== */
.ws-agent-edit-input, .ws-agent-edit-textarea, .ws-agent-edit-select {
  width: 100%; border: 1px solid var(--ws-line); border-radius: var(--ws-r-sm);
  padding: 8px 10px; font-size: 13.5px; background: var(--ws-panel);
  color: var(--ws-ink); font-family: inherit;
}
.ws-agent-edit-textarea { min-height: 96px; resize: vertical; line-height: 1.5; }
.ws-agent-save-bar {
  position: sticky; bottom: 0; background: var(--ws-panel);
  border-top: 1px solid var(--ws-line);
  padding: 12px 24px; display: flex; gap: 10px; justify-content: flex-end;
}

/* ===== Promote to org ===== */
.ws-promote-wrap {
  position: relative; display: inline-flex;
}
.ws-promote-wrap:hover .ws-promote-tooltip { opacity: 1; pointer-events: auto; }
.ws-promote-tooltip {
  position: absolute; top: 100%; left: 0; margin-top: 6px;
  background: var(--ws-ink); color: white; font-size: 11.5px; line-height: 1.5;
  padding: 8px 12px; border-radius: 8px; width: 260px;
  opacity: 0; pointer-events: none; transition: opacity 0.15s;
  z-index: 10;
}
.ws-modal-overlay {
  position: fixed; inset: 0; background: rgba(0,0,0,0.4);
  display: flex; align-items: center; justify-content: center;
  z-index: 1000;
}
.ws-promote-modal {
  background: var(--ws-panel); border-radius: 14px; width: 480px; max-width: 90vw;
  box-shadow: 0 24px 48px rgba(0,0,0,0.15); overflow: hidden;
}
.ws-promote-modal-head {
  display: flex; align-items: center; gap: 10px;
  padding: 20px 24px 0; color: var(--ws-ink);
}
.ws-promote-modal-head h2 {
  flex: 1; font-size: 16px; font-weight: 600; margin: 0;
}
.ws-promote-stats {
  padding: 18px 24px; display: flex; flex-direction: column; gap: 14px;
}
.ws-promote-stat-label {
  font-size: 12px; color: var(--ws-ink-3); margin-bottom: 5px; font-weight: 500;
}
.ws-promote-stat-row {
  display: flex; align-items: center; gap: 12px;
}
.ws-promote-bar {
  flex: 1; height: 6px; background: var(--ws-line); border-radius: 3px; overflow: hidden;
}
.ws-promote-bar-fill {
  height: 100%; border-radius: 3px; background: var(--ws-ink-4);
  transition: width 0.3s ease;
}
.ws-promote-bar-fill.ok { background: var(--ws-ok, #2F7A4E); }
.ws-promote-stat-num {
  font-size: 12px; font-weight: 600; color: var(--ws-ink-2);
  font-variant-numeric: tabular-nums; white-space: nowrap;
}
.ws-promote-pitch {
  padding: 0 24px 18px;
}
.ws-promote-pitch-label {
  display: flex; align-items: center; gap: 6px;
  font-size: 12px; font-weight: 600; color: var(--ws-ink-2); margin-bottom: 8px;
}
.ws-promote-textarea {
  width: 100%; border: 1px solid var(--ws-line); border-radius: 8px;
  padding: 12px; font-size: 13px; line-height: 1.55;
  resize: vertical; min-height: 80px; background: var(--ws-surface);
  color: var(--ws-ink); font-family: var(--ws-sans);
}
.ws-promote-textarea:focus { outline: none; border-color: var(--ws-ink-4); }
.ws-promote-pitch-hint {
  font-size: 11.5px; color: var(--ws-ink-4); margin-top: 6px;
}
.ws-promote-error {
  padding: 0 24px; font-size: 12px; color: var(--ws-err);
}
.ws-promote-actions {
  display: flex; gap: 10px; justify-content: flex-end;
  padding: 16px 24px; border-top: 1px solid var(--ws-line);
}

/* ===== Promotion progress (inline on Identity tab) ===== */
.ws-promo-progress {
  margin-top: 20px; padding: 16px;
  background: var(--ws-soft); border-radius: var(--ws-r-md);
}
.ws-promo-progress-header {
  display: flex; align-items: center; justify-content: space-between;
  margin-bottom: 14px;
}
.ws-promo-progress-title {
  display: flex; align-items: center; gap: 8px;
  font-size: 13px; font-weight: 600; color: var(--ws-ink-2);
  margin: 0;
}
.ws-promo-progress-row { margin-bottom: 12px; }
.ws-promo-progress-row:last-of-type { margin-bottom: 0; }
.ws-promo-progress-label {
  font-size: 12px; color: var(--ws-ink-3); margin-bottom: 5px; font-weight: 500;
}
.ws-promo-progress-bar-row { display: flex; align-items: center; gap: 12px; }
.ws-promo-progress-pending {
  font-size: 12px; color: var(--ws-warn); margin-top: 10px; font-weight: 500;
}
`;
